/* eslint-disable */

import * as clientService from "./httpsClient";

export const getOriginPackageTransportation = async (accessToken, params) => {
  try {
    const domain = `originpackagetransportations`;
    return await clientService.getApi(domain, accessToken, params);
  } catch (error) {
    throw error;
  }
};

export const searchOriginPackageTransportation = async (accessToken, params) => {
  const { transportation_id, reference, page, limit } = params || {};
  const trimmedReference = typeof reference === "string" ? reference.trim() : "";
  const query = {
    transportation_id,
    page: page || 1,
    limit: limit || 20,
    ...(trimmedReference ? { reference: trimmedReference } : {}),
  };

  try {
    const domain = `originpackagetransportations/search`;
    return await clientService.getApi(domain, accessToken, query);
  } catch (error) {
    console.error("[searchOriginPackageTransportation] error", error);
    throw error;
  }
};

export const getOriginPackage = async (accessToken, params) => {
  const { page, limit, reference, route } = params;
  let object = {
    reference: reference ? reference : undefined,
    page: page ? page : 0,
    limit: limit ? limit : 10,
    // route: route ? route : undefined,
  };

  try {
    const domain = `originpackage/listoriginpckagetransportation`;
    return await clientService.getApi(domain, accessToken, object);
  } catch (error) {
    throw error;
  }
};

export const getOriginPackageByID = async (accessToken, id, params) => {
  try {
    const domain = `originpackage/listoriginpckagetransportation/${id}`;
    return await clientService.getApi(domain, accessToken, params);
  } catch (error) {
    throw error;
  }
};

export const createOriginPackageTransportation = async (accessToken, body) => {
  try {
    const domain = `originpackagetransportations`;
    return await clientService.postApi(domain, accessToken, body);
  } catch (error) {
    throw error;
  }
};

export const deleteOriginPackageTransportation = async (accessToken, body) => {
  try {
    const domain = `originpackagetransportations`;
    return await clientService.deleteApi(domain, accessToken, body);
  } catch (error) {
    throw error;
  }
};
